import { useAuthenticator } from "@aws-amplify/ui-react";
import { Auth } from "aws-amplify";
import { ProgressSpinner } from "primereact/progressspinner";
import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { CognitoGroups } from "../../config/groups";
import { LoginScreen } from "./LoginScreen";

export const SecuredRoute = () => {
    const { authStatus } = useAuthenticator((context) => [
        context.authStatus
    ]);
    const [isAuthorized, setIsAuthorized] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        const checkUserAuth = async () => {
            setIsLoading(true);
            try {
                if (authStatus === "authenticated") {
                    const user = await Auth.currentAuthenticatedUser();
                    const groups = user.getSignInUserSession()?.getIdToken().payload[
                        "cognito:groups"
                    ];
                    if (groups && groups.includes(CognitoGroups.SUPER_ADMIN)) {
                        setIsAuthorized(true);
                    }
                }
            } catch (error) {
                console.error("Authentication error:", error);
            } finally {
                setIsLoading(false);
            }
        };
        
        checkUserAuth();
    }, [authStatus]);

    if (isLoading) {
        return (
            <div className="flex h-screen justify-content-center align-items-center">
                <ProgressSpinner />
            </div>
        );
    }

    if (authStatus !== "authenticated") {
        return <LoginScreen />;
    }

    if (!isAuthorized) {
        return (
            <div className="flex h-screen flex-column justify-content-center align-items-center">
                <h2>Access Denied</h2>
                <p>You don't have the required permissions to access this application.</p>
            </div>
        );
    }

    return <Outlet />;
};
